<nav class="sticky top-0 z-50">
  <div class="flex items-center justify-between px-6 py-1 mx-auto max-w-screen-2xl">
    <!-- Logo -->
    <a routerLink="/" dir="ltr" lang="en" class="flex items-center shrink-0">
      <img src="/images/website-logo-v2.png" alt="Awalan" class="w-38.5 h-16 object-contain" />
    </a>

    <!-- Desktop Menu -->
    <div class="justify-center flex-1 hidden md:flex">
      <ul class="flex items-center gap-8 text-white">
        <li>
          <a
            (click)="navigateToSection('hero')"
            class="cursor-pointer"
            [class.text-(--color-main)]="activeSection === 'hero'"
          >
            الرئيسية
          </a>
        </li>

        <li>
          <a
            routerLink="/about"
            routerLinkActive="text-(--color-main)"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            من نحن
          </a>
        </li>

        <li>
          <a
            routerLink="/projects"
            routerLinkActive="text-(--color-main)"
            [routerLinkActiveOptions]="{ exact: true }"
            class="cursor-pointer"
            [class.text-(--color-main)]="activeSection === 'performance'"
          >
            المشاريع
          </a>
        </li>

        <li>
          <a
            routerLink="/contact-us"
            routerLinkActive="text-(--color-main)"
            [routerLinkActiveOptions]="{ exact: true }"
            class="cursor-pointer"
          >
            تواصل معنا
          </a>
        </li>
      </ul>
    </div>

    <div class="items-center hidden gap-4 md:flex shrink-0">
      @if (showInvestment) {
        <button
          class="bg-(--color-main) text-(--color-secondary) h-10 px-10 rounded-[10px] font-semibold transition hover:bg-white hover:border-(--color-main) cursor-pointer"
          (click)="startInvestment()"
        >
          ابدأ تعاقدك
        </button>
      }

      <!-- Language Toggle (Desktop) -->
      <div class="relative lang-toggle">
        <button
          type="button"
          (click)="toggleLang()"
          class="bg-white text-(--color-secondary) px-3 py-2 rounded-md text-sm inline-flex items-center gap-2 cursor-pointer"
        >
          <svg class="w-4 h-4" fill="none" viewBox="0 0 10 6">
            <path stroke="currentColor" stroke-width="2" d="m1 1 4 4 4-4" />
          </svg>
          {{ currentLang.toUpperCase() }}
        </button>

        <div
          class="absolute z-50 mt-2 -translate-x-1/2 bg-white rounded-md shadow top-full left-1/2 w-28"
          [class.hidden]="!isLangOpen"
        >
          <ul class="py-2 text-sm text-(--color-secondary)">
            <li>
              <button
                (click)="setLang('en')"
                class="block w-full px-4 py-2 text-right hover:bg-gray-100"
              >
                EN
              </button>
            </li>
            <li>
              <button
                (click)="setLang('ar')"
                class="block w-full px-4 py-2 text-right hover:bg-gray-100"
              >
                AR
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- Mobile Toggle -->
    <button
      type="button"
      (click)="toggleMobileMenu()"
      class="flex items-center justify-center text-white border rounded-lg md:hidden w-11 h-11 border-white/30 hover:bg-white/10"
    >
      ☰
    </button>
  </div>
</nav>

<!-- Mobile Menu -->
@if (isMobileMenuOpen) {
  <div class="md:hidden fixed inset-0 z-50 bg-(--color-secondary)">
    <div class="flex items-center justify-between px-6 py-4 border-b border-white/20">
      <img src="/images/website-logo-v2.png" class="h-12" alt="Awalan" />
      <button
        type="button"
        (click)="toggleMobileMenu()"
        class="w-10 h-10 text-white rounded-lg hover:bg-white/10"
      >
        ✕
      </button>
    </div>

    <div class="px-6 py-8 space-y-6 text-lg text-right text-white">
      <!-- Language Toggle (Mobile) -->
      <div class="relative lang-toggle">
        <button
          type="button"
          (click)="toggleLang()"
          class="w-full bg-white text-(--color-secondary) px-4 py-3 rounded-md text-sm inline-flex items-center justify-between cursor-pointer"
        >
          <span>{{ currentLang.toUpperCase() }}</span>
          <svg class="w-4 h-4" fill="none" viewBox="0 0 10 6">
            <path stroke="currentColor" stroke-width="2" d="m1 1 4 4 4-4" />
          </svg>
        </button>

        <div class="w-full mt-2 bg-white rounded-md shadow" [class.hidden]="!isLangOpen">
          <button
            (click)="setLang('en')"
            class="block w-full text-right px-4 py-3 text-(--color-secondary) hover:bg-gray-100"
          >
            EN
          </button>
          <button
            (click)="setLang('ar')"
            class="block w-full text-right px-4 py-3 text-(--color-secondary) hover:bg-gray-100"
          >
            AR
          </button>
        </div>
      </div>

      <!-- Links -->
      <a (click)="navigateToSection('hero')" class="block cursor-pointer">الرئيسية</a>

      <a
        routerLink="/projects"
        (click)="isMobileMenuOpen = false"
        routerLinkActive="text-(--color-main)"
        [routerLinkActiveOptions]="{ exact: true }"
        class="block cursor-pointer"
        >المشاريع</a
      >

      <a
        routerLink="/about"
        (click)="isMobileMenuOpen = false"
        routerLinkActive="text-(--color-main)"
        [routerLinkActiveOptions]="{ exact: true }"
        class="block cursor-pointer"
        >من نحن</a
      >
      <a
        routerLink="/contact-us"
        (click)="isMobileMenuOpen = false"
        routerLinkActive="text-(--color-main)"
        [routerLinkActiveOptions]="{ exact: true }"
        class="block cursor-pointer"
        >تواصل معنا</a
      >

      @if (showInvestment) {
        <div class="flex justify-center pt-6">
          <button
            (click)="startInvestment()"
            class="w-[60%] bg-(--color-main) text-(--color-secondary) py-3 rounded-xl font-bold cursor-pointer"
          >
            ابدأ تعاقدك
          </button>
        </div>
      }
    </div>
  </div>
}
